import {allSettings, currentSettingsState} from '$lib/state/settings';
import {get, writable} from 'svelte/store';

export type SaveSettingsFlow = {
  step: 'IDLE' | 'CONFIRM';
};

const saveSettingsFlowStore = writable<SaveSettingsFlow>({step: 'IDLE'});

function actualSave() {
  allSettings.saveCurrent();
}

export const saveSettingsFlow = {
  subscribe: saveSettingsFlowStore.subscribe,
  save() {
    const state = get(currentSettingsState);
    if (state.inList && state.changed) {
      saveSettingsFlowStore.set({step: 'CONFIRM'});
    } else {
      actualSave();
    }
  },
  confirm() {
    actualSave();
    saveSettingsFlowStore.set({step: 'IDLE'});
  },
  cancel() {
    saveSettingsFlowStore.set({step: 'IDLE'});
  },
};
